import * as React from 'react'
export const SvgPencil = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M3.893 17L7 20.112l-3.243.884a.687.687 0 01-.155 0 .596.596 0 01-.577-.765L3.893 17zM14.48 6L18 9.523 8.527 19 5 15.483 14.479 6zm3.732-2.912l.092.075 2.527 2.53a.576.576 0 010 .817L19.343 8l-.81-.811-1.723-1.726-.81-.805 1.488-1.495a.602.602 0 01.724-.075z" />
  </svg>
)
export default SvgPencil
